import { render, staticRenderFns } from "./IcoKitchen.vue?vue&type=template&id=77e425d7&scoped=true"
import script from "./IcoKitchen.vue?vue&type=script&lang=js"
export * from "./IcoKitchen.vue?vue&type=script&lang=js"
import style0 from "./IcoKitchen.vue?vue&type=style&index=0&id=77e425d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e425d7",
  null
  
)

export default component.exports